import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import formationsSeaStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formationsSea'
const customImplement: CustomStoreImplementationOptions = formationsSeaStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsSeaFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('prog-02-sea.title', 'Formation en SEA'),
        $description: $translate('prog-02-sea.description', 'Sur-mesure et sans aucun coût à votre charge, cette formation en SEA vous permettra de maîtriser les outils publicitaires de Google pour créer des campagnes performantes et booster votre visibilité en ligne.'),
        $publishedTime: new Date('2023-02-13T07:42:17.600Z'),
        $modifiedTime: new Date('2023-09-06T12:36:37.780Z'),
        // Constants,
        $constants: {
          blocPreviewProfilExpertTags: [
            { Nom: 'Growth marketing' },
            { Nom: 'Publicité' },
            { Nom: 'SEO/SEA/SEM' },
            { Nom: 'Social media/Ads' },
            { Nom: 'Notoriété' },
            { Nom: 'Trafic management' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element1Tags: [
            { Nom: 'Google Analytics' },
            { Nom: 'Google Ads' },
            { Nom: 'Google Tag Manager' },
            { Nom: 'Audits' },
            { Nom: 'E-commerce' },
            { Nom: 'Facebook & Instagram' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element2Tags: [
            { Nom: 'Google Analytics' },
            { Nom: 'Google Ads' },
            { Nom: 'Rédaction web' },
            { Nom: 'Webmarketing' },
            { Nom: 'Social media' },
            { Nom: 'Stratégie digitale' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element3Tags: [
            { Nom: 'Campagnes d\'acquisition' },
            { Nom: 'SEA' },
            { Nom: 'Tracking' },
            { Nom: 'Plan media' },
            { Nom: 'Conversion' },
            { Nom: 'Landing page' },
            { Nom: 'Web analyse' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          dropDownFormationArguments: [
            { Text: '<ul><li>Définir des objectifs prioriser ses cibles.</li></ul>' },
            { Text: '<ul><li>Étudier les caractéristiques de chaque média : Google et Facebook.</li></ul>' },
            { Text: '<ul><li>Définir un budget d’après ses objectifs.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element4Arguments: [
            { Text: '<ul><li>Mettre en place efficacement sa campagne : stratégie, création, rédaction et tracking.</li></ul>' },
            { Text: '<ul><li>Optimiser la performance de cette campagne dans le temps.</li></ul>' },
            { Text: '<ul><li>Annalyser les résultats.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element5Arguments: [
            { Text: '<ul><li>Mettre en place efficacement sa campagne : stratégie, création, rédaction et tracking.</li></ul>' },
            { Text: '<ul><li>Optimiser la performance de cette campagne dans le temps.</li></ul>' },
            { Text: '<ul><li>Analyser les résultats.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element6Arguments: [
            { Text: '<ul><li>Savoir utiliser les fonctions avancées de Google Analytics.&nbsp;</li></ul>' },
            { Text: '<ul><li>Savoir mettre en place et utiliser les outils d’analyse du parcours client type Hotjar.</li></ul>' },
            { Text: '<ul><li>Identifier, mettre en place, lire et analyser les KPI clés d’acquisition de trafic.</li></ul>' },
            { Text: '<ul><li>Identifier, mettre en place, lire et analyser les KPI clés du tunnel de conversion.</li></ul>' },
            { Text: '<ul><li>Créer des règles d’alertes pour un suivi efficace.</li></ul>' },
            { Text: '<ul><li>Création d’un tableau de bord sur Google Data Studio.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>
        },
        // Data,
        $data: { seoImage: undefined as Nullable<string> },
        $info: { prog02Sea: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      blocPreviewProfilExpertClick () {
        openUrl('https://www.matchers.fr/expert/245', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element1Click () {
        openUrl('https://www.matchers.fr/expert/430', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element2Click () {
        openUrl('https://www.matchers.fr/expert/482', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element3Click () {
        openUrl('https://www.matchers.fr/expert/195', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      voirClick () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsSeaFactory(storeId)()
}

export const formationsSeaRaw = formationsSeaFactory()
export const formationsSea = () => formationsSeaRaw() as MergeCustomStore<typeof formationsSeaStoreCustom.instance>
